export const DASHBOARD = '/';
export const LOGIN = '/login';
export const CHANGE_PASSWORD = '/change-password';
export const RESET_PASSWORD = '/reset-password';
